export const REPORT = {
  report_aml: "AML",
  report_adverse_media: "Adverse Media",
  report_all: "All",
};

export const REPORT_OPTIONS = [
  { name: REPORT["report_all"], value: "report_all" },
  { name: REPORT["report_aml"], value: "report_aml" },
  { name: REPORT["report_adverse_media"], value: "report_adverse_media" },
];
